import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

/* ======================================
   Core socket creator (single instance)
====================================== */
function createSocket(): Socket {
  return io(process.env.REACT_APP_BACKEND_URL || "http://localhost:5000", {
    transports: ["websocket"],
    withCredentials: true,
    autoConnect: true,
  });
}

/* ======================================
   Preferred method going forward
====================================== */
export function getSocket(): Socket {
  if (!socket) {
    socket = createSocket();

    socket.on("connect", () => {
      console.log("🟢 Global socket connected:", socket?.id);
    });

    socket.on("disconnect", () => {
      console.log("🔴 Global socket disconnected");
    });

    socket.on("connect_error", (err) => {
      console.error("🔴 Socket connect_error:", err.message);
    });
  }

  return socket;
}

/* ======================================
   BACKWARD COMPATIBILITY (important)
   So existing imports don't break
====================================== */
export async function initSocket(): Promise<Socket> {
  return getSocket();
}
